import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-date-time',
  templateUrl: './date-time.component.html',
  styleUrls: ['./date-time.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateTimeComponent),
      multi: true
    }
  ]
})
export class DateTimeComponent {
  dateTime: string;// = '2024-10-29T13:27:33.4156371+11:00';
  timeZone: string;

  private onChange: (value: string) => void;
  private onTouched: () => void;

  writeValue(value: string): void {
    if (value != null){
      // Parse the incoming date string and format it for datetime-local input
      // The datetime-local input expects format: YYYY-MM-DDTHH:mm
      const date = new Date(value);
      
      // Get local time components
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      
      // Format for datetime-local input
      this.dateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
      
      // Get timezone offset in hours
      const timezoneOffset = -date.getTimezoneOffset() / 60;
      this.timeZone = (timezoneOffset >= 0 ? '+' : '') + String(timezoneOffset).padStart(2, '0') + ':00';
    } else {
      this.dateTime = '';
      const date = new Date();
      const timezoneOffset = -date.getTimezoneOffset() / 60;
      this.timeZone = (timezoneOffset >= 0 ? '+' : '') + String(timezoneOffset).padStart(2, '0') + ':00';
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle the disabled state if needed
  }

  onDateTimeChange() {
    if (this.onChange && this.dateTime) {
      // Construct ISO 8601 format datetime string with timezone
      // Format: YYYY-MM-DDTHH:mm:ss.ffffff+HH:mm
      const isoDateTime = this.dateTime + ":00.000000" + this.timeZone;
      console.log('Date-time changed:', isoDateTime);
      this.onChange(isoDateTime);
    }
  }

  onBlur() {
    if (this.onTouched) {
      this.onTouched();
    }
  }
}